import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface TcAccordionSectionProps {
  id?: string;
  panelId: string;
  title: string;
  subtitle: string;
  expanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  className?: string;
}

const TcAccordionSection: React.FC<TcAccordionSectionProps> = ({
  id,
  panelId,
  title,
  subtitle,
  expanded,
  onToggle,
  children,
  className = '',
}) => (
  <Accordion
    id={id}
    className={className || undefined}
    expanded={expanded}
    onChange={onToggle}
    disableGutters
    square
    sx={{ border: `1px solid`, borderColor: 'divider', '&:before': { display: 'none' } }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      id={`${panelId}-trigger`}
      aria-controls={panelId}
    >
      <Box>
        <Typography component="strong" sx={{ display: 'block', fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography component="small" variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails id={panelId} role="region" aria-labelledby={`${panelId}-trigger`}>
      {children}
    </AccordionDetails>
  </Accordion>
);

export default TcAccordionSection;

export function tcAccordionListSubtitle(
  expanded: boolean,
  count: number,
  itemLabel: string,
  emptyLabel: string,
): string {
  if (expanded) return `Recolher lista de ${itemLabel}`;
  if (count === 0) return emptyLabel;
  const plural = count === 1 ? '' : 's';
  return `Expandir para ver ${count} ${itemLabel}${plural}`;
}
